import { render, staticRenderFns } from "./ButtonValidation.vue?vue&type=template&id=50735164"
import script from "./ButtonValidation.vue?vue&type=script&lang=js"
export * from "./ButtonValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports